(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.subscribeCard = {
    attach: function (context, settings) {
      $.fn.subscribeCardAjaxFormSubmit = function () {
        $('.component-card-subscribe-card').each(function (index) {
          if ($(this).find('.webform-confirmation').length) {
            $(this).find('.icon-default').addClass('hidden');
            $(this).find('.icon-success').removeClass('hidden');
          }
        });
      };
    }
  };
})(jQuery, Drupal, drupalSettings);
